import AcUnitIcon from "@mui/icons-material/AcUnit";
import { getFlag } from "../utils/ApiCalls/FlagCalls";
import { FLAGS } from "../utils/Constant/FlagConstant";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ArticleIcon from "@mui/icons-material/Article";
import BookIcon from "@mui/icons-material/Book";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import LanguageIcon from "@mui/icons-material/Language";
import LaptopChromebookIcon from "@mui/icons-material/LaptopChromebook";
import MovieIcon from "@mui/icons-material/Movie";
import CampaignIcon from "@mui/icons-material/Campaign";
import FaceIcon from "@mui/icons-material/Face";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import SailingIcon from "@mui/icons-material/Sailing";
import TuneIcon from "@mui/icons-material/Tune";
import AdUnitsIcon from "@mui/icons-material/AdUnits";
import PaymentIcon from "@mui/icons-material/Payment";
import { getfindAllPagesMenu } from "../utils/ApiCalls/MenuList";
import { getEntertainmentRevenueCenterMenu } from "../utils/ApiCalls/BackOffice/Entertainment";

const getMenus = async () => {
  try {
    const res = await getfindAllPagesMenu();
    return res?.menus ?? [];
  } catch (error) {
    console.error("Error fetching menus:", error);
    return [];
  }
};

export const loadMenus = async () => {
  const allPagesMenus = await getMenus();
  // API groups revenue centers by vessel (data-level grouping), but the
  // sidebar shows them as one flat list under "Revenue Center" - no vessel
  // layer in the displayed hierarchy
  const revenueCenterMenusByVessel = await getEntertainmentRevenueCenterMenu();
  const revenueCenterMenus = revenueCenterMenusByVessel.flatMap(
    (vessel) => vessel.subMenu || []
  );
  const popupEnabled = (await getFlag(FLAGS.WEB_POPUP)).enabled;
  const appPhase2Enabled = (await getFlag(FLAGS.APP_PHASE_2)).enabled;
  const appPhase2OnboardEnabled = (await getFlag(FLAGS.APP_PHASE_2_ONBOARD)).enabled;
  const appPhase2OnboardEntertainmentEnabled = (
    await getFlag(FLAGS.APP_PHASE_2_ONBOARD_ENTERTAINMENT)
  ).enabled;

  const sideMenu = [
    {
      title: "Website",
      icon: <LaptopChromebookIcon />,
      link: "/website",
      subMenu: [
        {
          title: "CMS",
          icon: <NewspaperIcon />,
          link: "/cms",
          subMenu: [
            {
              title: "Homepage",
              link: "/homepage",
              subMenu: [
                {
                  title: "Announcement",
                  link: "/announcement",
                },
                {
                  title: "Banner",
                  link: "/banner",
                },
                {
                  title: "Destinations",
                  link: "/destinations",
                },
                {
                  title: "Home",
                  link: "/home",
                },
                {
                  title: "Experience",
                  link: "/experience",
                },
                {
                  title: "Menubar",
                  link: "/menubar",
                },
              ],
            },
            {
              title: "Crisis page",
              link: "/crisis-page",
              subMenu: [
                {
                  title: "Crisis Popup",
                  link: "/crisis-popup",
                },
                {
                  title: "Crisis Data",
                  link: "/Crisis-data",
                },
              ],
            },

            {
              title: "Packages",
              icon: <SailingIcon />,
              link: "/packages",
            },
            {
              title: "Promo Index",
              icon: <ArticleIcon />,
              link: "/promo-index",
            },
            {
              title: "Special Pages",
              icon: <BookIcon />,
              link: "/special-pages",
            },
            {
              title: "Newsletter",
              icon: <ArticleIcon />,
              link: "/news-letter",
            },
          ],
        },
        {
          title: "Masters",
          icon: <TuneIcon />,
          link: "/masters",
          subMenu: [
            {
              title: "Markets",
              link: "/markets",
            },
            {
              title: "Cabin Master",
              link: "/cabin-master",
            },
            {
              title: "Cabin Types",
              link: "/cabin-types",
            },
            {
              title: "Cabin Category",
              link: "/cabin-category",
            },
            {
              title: "Ancillary",
              link: "/ancillary-details",
            },
          ],
        },
        {
          title: "Bookings",
          icon: <CalendarMonthIcon />,
          link: "/bookings",
          subMenu: [
            {
              title: "Cabin Bookings",
              link: "/cabin-booking",
            },
            {
              title: "Failed Bookings",
              link: "/leads",
            },
            {
              title: "Error Module",
              link: "/error-module",
            },
            {
              title: "Best Price",
              link: "/best-price",
            },
          ],
        },
        {
          title: "Loyalty",
          icon: <FaceIcon />,
          link: "/loyalty",
          subMenu: [
            {
              title: "Card Type",
              link: "/card-types",
            },
            {
              title: "DRS Instance",
              link: "/drs-instance",
            },
            {
              title: "Currency",
              link: "/currency",
            },
            {
              title: "Member Bookings",
              link: "/member-bookings",
            },
            {
              title: "Loyalty Logs",
              link: "/loyalty-logs",
            },
          ],
        },
        {
          title: "Blog",
          icon: <LaptopChromebookIcon />,
          link: "/webpages/blog",
        },
        {
          title: "Vlog",
          icon: <MovieIcon />,
          link: "/webpages/vlog",
        },
        ...(popupEnabled ? [{
          title: "Popup",
          icon: <CampaignIcon/>,
          link: "/webpages/popup",
        }] : []),
        {
          title: "SEO Meta Tag",
          icon: <ArticleIcon />,
          link: "/webpages/seo-meta-tag",
        },
        {
          title: "Webpages",
          icon: <LanguageIcon />,
          link: "/webpages",
          subMenu: [
            {
              icon: <LaptopChromebookIcon />,
              title: "Templates",
              link: "/templates",
            },
            {
              icon: <AcUnitIcon />,
              title: "Deals",
              link: "/deals",
              subMenu: [
                {
                  title: "Celebration Packages",
                  link: "/celebration-packages",
                },
                {
                  title: "Onboard Promotions",
                  link: "/onboard-promotions",
                },
                {
                  title: "Cash Vouchers",
                  link: "/cash-vouchers",
                },
              ],
            },
            {
              icon: <DirectionsBoatIcon />,
              title: "MICE",
              link: "/mice",
            },
            {
              icon: <DirectionsBoatIcon />,
              title: "Ships",
              link: "/ships",
            },
            {
              icon: <DirectionsBoatIcon />,
              title: "Destinations",
              link: "/destinations",
            },

            {
              icon: <MovieIcon />,
              title: "Experiences",
              link: "/experiences",
              subMenu: [
                {
                  title: "The Palace",
                  link: "/the-palace",
                },
                {
                  title: "Little Dreamers",
                  link: "/little-dreamers",
                },
                {
                  title: "Entertainment",
                  link: "/entertainment",
                },
                {
                  title: "Life at RWC",
                  link: "/life-at-rwc",
                },
                {
                  title: "Events",
                  link: "/events",
                },
              ],
            },
            {
              icon: <MovieIcon />,
              title: "About Us",
              link: "/about-us",
              subMenu: [
                {
                  title: "Our Story",
                  link: "/our-story",
                },
                {
                  title: "Balcony Class",
                  link: "/balcony-class",
                },
                {
                  title: "Safety Guides",
                  link: "/safety-guides",
                },
                {
                  title: "Brochures and Guides",
                  link: "/brochures-guides",
                },
                {
                  title: "FAQ",
                  link: "/faq",
                },
              ],
            },
            {
              icon: <MovieIcon />,
              title: "Footer",
              link: "/footer",
              subMenu: [
                {
                  title: "Bill of Rights",
                  link: "/bill-of-rights",
                },
                {
                  title: "Privacy Policy",
                  link: "/privacy-policy",
                },
                {
                  title: "Cookie Policy",
                  link: "/cookie-policy",
                },
                {
                  title: "Terms of Usage",
                  link: "/terms-of-usage",
                },
                {
                  title: "Passage Terms",
                  link: "/passage-terms",
                },
                {
                  title: "Terms And Conditions",
                  link: "/terms-and-conditions",
                },
                {
                  title: "Career",
                  link: "/career",
                },
                {
                  title: "Media & Resources",
                  link: "/press-releases",
                },
                {
                  title: "Contact Us",
                  link: "/contact-us",
                },
              ],
            },
            {
              icon: <MovieIcon />,
              title: "Header",
              link: "/header",
              subMenu: [
                {
                  title: "Prepare For Your Cruise",
                  link: "/prepare-for-your-cruise",
                },
                {
                  title: "Know Before You Sail",
                  link: "/know-before-you-sail",
                },
                {
                  title: "Best price guarantee",
                  link: "/best-price-guarantee",
                },
              ],
            },
            {
              title: "Login Page",
              icon: <AccountCircleIcon />,
              link: "/login-page",
            },
          ],
        },
      ],
    },
    {
      title: "Mobile CMS App",
      icon: <AdUnitsIcon />,
      link: "/shore",
      subMenu: [
        {
          title: "Masters",
          icon: <TuneIcon />,
          link: "/mobile-masters",
          subMenu: [
            { title: "Categories", link: "/activity-categories" },
            { title: "Venues", link: "/venue" },
            {
              title: "Itinerary",
              link: "/packages",
            },
            { title: "Currency", link: "/sailing_currency" },
            ...(appPhase2OnboardEntertainmentEnabled
              ? [{ title: "Age Validation", link: "/age-validation" }]
              : []),
          ],
        },
        ...(appPhase2Enabled ? [{
          title: "Mobile Ancillary",
          icon: <PaymentIcon />,
          link: "/mobile-ancillary",
          subMenu: [
            { title: "Ancillary Purchases", link: "/purchases" },
            { title: "Error Module", link: "/error-module" },
            { title: "Seaware Ancillary CMS", link: "/seaware-ancillary" },
          ],
        }] : []),
        {
          title: "All Pages",
          icon: <TuneIcon />,
          link: "/all-pages",
          subMenu: allPagesMenus, // fetched menus
        },
        {
          title: "Manage Cruise",
          icon: <TuneIcon />,
          link: "/cruise-page",
          subMenu: [
            {
              title: "Genting Dream",
              link: "/genting-dream",
            },
            {
              title: "Star Navigator",
              link: "/star-navigator",
            },
            {
              title: "Star Voyager",
              link: "/star-voyager",
            },
          ], // fetched menus
        },
        {
          title: "Daily Planner",
          icon: <TuneIcon />,
          link: "/daily-planner",
          subMenu: [
            {
              title: "Genting Dream",
              link: "/genting-dream",
            },
            {
              title: "Star Navigator",
              link: "/star-navigator",
            },
            {
              title: "Star Voyager",
              link: "/star-voyager",
            },
          ], // fetched menus
        },
        {
          title: "Shortcuts",
          icon: <TuneIcon />,
          link: "/ship-shortcuts",
          subMenu: [
            {
              title: "Genting Dream",
              link: "/genting-dream",
            },
            {
              title: "Star Navigator",
              link: "/star-navigator",
            },
            {
              title: "Star Voyager",
              link: "/star-voyager",
            },
          ], // fetched menus
        },

        {
          title: "Category Sequence",
          icon: <TuneIcon />,
          link: "/home-page",
          subMenu: [
            {
              title: "Genting Dream",
              link: "/genting-dream",
            },
            {
              title: "Star Navigator",
              link: "/star-navigator",
            },
            {
              title: "Star Voyager",
              link: "/star-voyager",
            },
          ], // fetched menus
        },

        {
          title: "Notifications",
          icon: <TuneIcon />,
          link: "/notifications",
        },
        {
          title: "Webpages",
          icon: <TuneIcon />,
          link: "/webpages",
          subMenu: [
            {
              title: "Safety Information",
              icon: <LaptopChromebookIcon />,
              link: "/legal/mobile-safety-and-guides",
              space: "10px",
            },
            {
              title: "Legal",
              icon: <LaptopChromebookIcon />,
              link: "/legal",
              space: "10px",
              subMenu: [
                {
                  title: "Bill of Rights",
                  link: "/mobile-bill-of-rights",
                  space: "10px",
                },
                {
                  title: "Privacy Policy",
                  link: "/mobile-privacy-policy",
                  space: "10px",
                },
                {
                  title: "Cookie Policy",
                  link: "/mobile-cookie-policy",
                  space: "10px",
                },
                {
                  title: "Terms of Usage",
                  link: "/mobile-terms-of-usage",
                  space: "10px",
                },
                {
                  title: "Passage Terms",
                  link: "/mobile-passage-terms",
                  space: "10px",
                },
                {
                  title: "Terms And Conditions",
                  link: "/mobile-terms-and-conditions",
                  space: "10px",
                },
              ],
            },
          ],
        },
        ...(appPhase2OnboardEnabled || appPhase2OnboardEntertainmentEnabled ? [{
          title: "Back Office",
          icon: <TuneIcon />,
          link: "/back-office",
          subMenu: [
            ...(appPhase2OnboardEnabled ? [{
              title: "Shore Excursions",
              icon: <LaptopChromebookIcon />,
              link: "/shore-excursions",
              subMenu: [
                { title: "Management", link: "/management" },
                {
                  title: "Report",
                  link: "/report",
                  subMenu: [
                    { title: "Sales Reports", link: "/sales", space: "10px" },
                    { title: "Summary Report", link: "/summary", space: "10px" },
                  ],
                },
                { title: "Void Transaction", link: "/void-transaction" },
              ],
            }] : []),
            ...(appPhase2OnboardEntertainmentEnabled ? [{
              title: "Onboard Purchase",
              icon: <LaptopChromebookIcon />,
              link: "/entertainment",
              subMenu: [
                { title: "Management", link: "/management" },
                {
                  title: "Revenue Center",
                  link: "/revenue-center",
                  subMenu: revenueCenterMenus,
                },
                {
                  title: "Report",
                  link: "/report",
                  subMenu: [
                    { title: "Sales Reports", link: "/sales", space: "10px" },
                    { title: "Summary Report", link: "/summary", space: "10px" },
                  ],
                },
                { title: "Void Transaction", link: "/void-transaction" },
              ],
            }] : []),
          ],
        }] : []),
      ],
    },
    {
      title: "Profile",
      icon: <AccountCircleIcon />,
      link: "/profile",
      subMenu: [
        { title: "My Profile", link: "/my-profile" },
        { title: "Roles", link: "/role" },
        { title: "User Management", link: "/user-management" },
        { title: "Reset Password", link: "/reset-password" },
      ],
    },
    {
      title: "Logs",
      icon: <CalendarMonthIcon />,
      link: "/logs",
      subMenu: [
        { title: "Log API", link: "/log-api" },
        { title: "User Logs", link: "/user-logs" },
      ],
    },
    {
      title: "Logout",
      onClick: () => {
        localStorage.removeItem("token");
      },
      icon: <PowerSettingsNewIcon />,
    },
  ];

  return { sideMenu };
};
